import { useEffect, useState } from 'react';
import { CtaButton } from './cta-button';

/**
 * C4 Sticky bottom bar · reveal after fold · hairline · mobile only.
 *
 * The masthead (N6) is in document flow and scrolls away, so on small screens
 * this carries the persistent action. Suppressed at `lg` and above, where the
 * page's own section CTAs stay within reach.
 */
export function StickyCta() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta"
      aria-hidden={!shown}
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-line-strong bg-background/95 backdrop-blur-sm transition-[opacity,transform] duration-200 ease-out lg:hidden motion-reduce:transition-none ${
        shown
          ? 'translate-y-0 opacity-100'
          : // `invisible` (not just opacity-0) keeps the CTA out of the tab order
            // while the bar is retracted.
            'invisible translate-y-full opacity-0'
      }`}
    >
      <div className="flex items-center justify-between gap-4 px-4 py-3">
        {/* text-xs keeps this to one line at 375px, so the bar stays ~56px tall. */}
        <p className="min-w-0 text-xs leading-snug text-foreground/65 sm:text-sm">
          First report within 7 business days.
        </p>
        <CtaButton location="sticky_bar" variant="clay" size="sm" depth="3d" className="shrink-0">
          Start Monitoring
        </CtaButton>
      </div>
    </div>
  );
}
